import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { ControlledToggleButtonGroup } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

type Props = {
  enable?: boolean;
  control: Control<any>;
  editAppointmentType?: 'ONLY_THIS' | 'THIS_AND_ALL_SUBSEQUENT' | undefined;
  hasDirtiedFields?: boolean;
  hasSpecifiedRecurrence?: boolean;
};

const WhichSection = ({
  enable,
  control,
  hasDirtiedFields,
  hasSpecifiedRecurrence,
  editAppointmentType
}: Props) => {
  const { t } = useTranslation();

  if (!enable) return null;

  return (
    <MultiStepForm.Section
      title="Welke"
      validateFields={['editAppointmentType']}
      isImportant={!hasDirtiedFields || !hasSpecifiedRecurrence}
    >
      <Box>
        <ControlledToggleButtonGroup
          control={control}
          name="editAppointmentType"
          color="secondary"
          aria-label="alignment"
          inputToggleButtons={[
            {
              label: t('activityPlanning.onlyThisAppointment'),
              value: 'ONLY_THIS',
              selected: editAppointmentType === 'ONLY_THIS',
              disabled: !hasDirtiedFields
            },
            {
              label: t('activityPlanning.thisAndSubsequentAppointments'),
              value: 'THIS_AND_ALL_SUBSEQUENT',
              selected: editAppointmentType === 'THIS_AND_ALL_SUBSEQUENT',
              disabled: !hasDirtiedFields
            }
          ]}
        />
      </Box>
    </MultiStepForm.Section>
  );
};

export default WhichSection;
